import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '../../node_modules/@dnd-kit/sortable/dist/sortable.esm.js';
import { CSS } from '../../node_modules/@dnd-kit/utilities/dist/utilities.esm.js';

function SortableItem(_ref) {
  var id = _ref.id,
    children = _ref.children;
  var _useSortable = useSortable({
      id: id
    }),
    attributes = _useSortable.attributes,
    listeners = _useSortable.listeners,
    setNodeRef = _useSortable.setNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition;
  var style = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("div", _extends({
      ref: setNodeRef,
      style: style
    }, attributes, listeners), /*#__PURE__*/React.createElement("li", null, children))
  );
}
SortableItem.propTypes = {
  id: PropTypes.node.isRequired,
  value: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired
};

export { SortableItem };
